import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, Subject, Observer } from 'rxjs';
import { CrudService } from '.';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { GenericResponse, GenericSearchResponse, Gasto, SaveGastoRequestDto, GastoAdjunto, UploadGastoAttachResponseDto, SearchGastoRequest, SearchPendientesLiquidacionRequest } from '../model';
import { GenericPieDashboardResponse, DashboardGastosPorServicioRequest, DashboardGastosPorTipoGastoRequest, SaveGastoMovimientoDto, SaveGastoFromDocumentRequestDto, SaveGastoFromDocumentResponseDto, SearchGastoRecurrenteRequest } from '../model';

@Injectable({
  providedIn: 'root'
})

export class GastoService extends CrudService<Gasto, number, SaveGastoRequestDto, SearchGastoRequest> { 
  constructor(protected _http: HttpClient, private datePipe: DatePipe, protected sharedFunctions: SharedFunctions) {
    super(_http,'gasto', sharedFunctions);
  }

  getDashboardMisGastosUrl() {
    return this._serviceUrl + '/dashboard-mis-gastos';
  }

  getMySearchUrl() {
    return this._serviceUrl + '/my-search';
  }

  getAttachments(id: number): Observable<GenericResponse<GastoAdjunto[]>> {
    return this._http.get<GenericResponse<GastoAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getSearchEstadisticas(p: SearchGastoRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/search-statistics' + query, this.httpOptions);
  }

  getMySearchEstadisticas(p: SearchGastoRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/my-search-statistics' + query, this.httpOptions);
  }

  mySearch(value: SearchGastoRequest): Observable<GenericSearchResponse<any>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericSearchResponse<any>>(this._serviceUrl + '/my-search' + queryString, this.httpOptions);
  }

  exportMySearch(value: SearchGastoRequest): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/my-export-search' + queryString, this.httpCsvOptions);
  }

  searchPendientesLiquidacion(p: SearchPendientesLiquidacionRequest): Observable<GenericSearchResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericSearchResponse<any>>(this._serviceUrl + '/search-pendientes-liquidacion' + query, this.httpOptions);
  }

  getGastosRecurrentes(p: SearchGastoRecurrenteRequest): Observable<any> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<any>(this._serviceUrl + '/gastos-recurrentes'  +query, this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  cleanTempFolderUrl(): string {
    return this._serviceUrl + '/clean/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadGastoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadGastoAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  clearTempFolder(): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this.cleanTempFolderUrl(), null, this.httpOptions);
  }

  permitirGenerarInteres(id: number, value: boolean): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/' + id + '/generar-interes/'+value, null, this.httpOptions);
  }

  crearMovimiento(p: SaveGastoMovimientoDto): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl + '/crear-movimiento/'+p.GastoId, p, this.httpOptions);
  }

  obtenerDashboardGastosPorServicio(p: DashboardGastosPorServicioRequest): Observable<GenericResponse<GenericPieDashboardResponse>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<GenericPieDashboardResponse>>(this._serviceUrl + '/dashboard-gastos-por-servicio' + query, this.httpOptions);
  }

  obtenerDashboardGastosPorTipoGasto(p: DashboardGastosPorTipoGastoRequest): Observable<GenericResponse<GenericPieDashboardResponse>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<GenericPieDashboardResponse>>(this._serviceUrl + '/dashboard-gastos-por-tipo-gasto' + query, this.httpOptions);
  }

  generarGastosRecurrentes(p: SaveGastoRequestDto[]) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/generar-gastos-recurrentes", p, this.httpOptions);
  }

  generarGastos(p: SaveGastoRequestDto[]) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/generar-gastos", p, this.httpOptions);
  }

  generarDesdeDocumentos(p: SaveGastoFromDocumentRequestDto) : Observable<GenericResponse<SaveGastoFromDocumentResponseDto>> {
    return this._http.post<GenericResponse<SaveGastoFromDocumentResponseDto>>(this._serviceUrl+"/generar-desde-documentos", p, this.httpOptions);
  }
}